var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',{attrs:{"type":"card"}},[_c('template',{slot:"header"},[_vm._v("\n    当前状态 "+_vm._s(_vm.active ? '开启过渡动画' : '关闭过渡动画')+"\n  ")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.set(!_vm.active)}}},[_vm._v("\n    "+_vm._s(_vm.active ? '关闭页面过渡动画' : '打开页面过渡动画')+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }